import { HttpErrorResponse, HttpEvent, HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { catchError, Observable, throwError } from 'rxjs';

export const userInactiveInterceptor: HttpInterceptorFn = (req, next): Observable<HttpEvent<unknown>> => {
  const router = inject(Router);

  return next(req).pipe(
    catchError((err: unknown) => {
      if (err instanceof HttpErrorResponse) {
        // Avoid redirect loops on OIDC / discovery / logout calls
        const url = (req.url || '').toLowerCase();
        const isAuthCall =
          url.includes('/.well-known') ||
          url.includes('/signin-oidc') ||
          url.includes('/signout-callback') ||
          url.includes('/logout') ||
          url.includes('/token') ||
          url.includes('/authorize');

        if (!isAuthCall && err.status === 403) {
           router.navigateByUrl('/unauthorized');
            return throwError(() => err);
        }
      }
      return throwError(() => err);
    })
  );
};
